module.exports = __webpack_public_path__ + "static/media/ex1.33f77615.jpg";